export const compliance = {
list: {
  chaseFailedBody: "تحقق من اتصالك وحاول مرة أخرى. إذا استمر الفشل، افتح المستند وصدّق عليه بنفسك أو اسأل المصدّق مباشرة.",
  chaseFailedTitle: "لم يُرسل التذكير",
  chaseSentBodyUnnamed: "سيتلقى المصدّق إشعارًا للتصديق عليه. يتلقى كل شخص تذكيرًا واحدًا في اليوم على الأكثر.",
  chaseSentBody: "سيتلقى {{name}} إشعارًا للتصديق عليه. يتلقى كل شخص تذكيرًا واحدًا في اليوم على الأكثر.",
  chaseSentTitle: "تم إرسال التذكير",
  showWorkspace: "عرض مساحة العمل كاملة",
  noWorkspaceDescription: "يُعرض الامتثال لمساحة عمل. انضم إلى مساحة أو أنشئ واحدة لرؤيته هنا.",
title: "الامتثال",
subtitle_one: "{{count}} متطلب",
subtitle_other: "{{count}} متطلب",
searchPlaceholder: "ابحث في الأصول والمستندات",
searchA11y: "البحث في الامتثال",
refine: "تصفية",
refineSheetTitle: "تصفية الامتثال",
clearFilters: "مسح المرشحات",
loadMore: "تحميل المزيد",
emptyTitle: "لا يوجد ما يجب إثباته حتى الآن",
emptyDescription: "افتح أصلًا وأضف شهادة أو مستندًا آخر بتاريخ انتهاء. سيظهر هنا مع موعد استحقاقه.",
emptyAction: "الانتقال إلى الأصول",
noMatchTitle: "لا توجد متطلبات مطابقة",
noMatchDescription: "لا توجد متطلبات امتثال مطابقة للمرشحات التي طبّقتها.",
errorTitle: "تعذّر تحميل بيانات الامتثال",
unscopedTitle: "اختر مساحة عمل",
unscopedDescription: "يشمل الامتثال مساحة العمل كلها، وأنت تعرض عناصرك فقط. اضغط عرض مساحة العمل كاملة.",
subtitle_zero: "لا متطلبات",
subtitle_two: "متطلبان",
subtitle_few: "{{count}} متطلبات",
subtitle_many: "{{count}} متطلبًا",
},
bucket: {
compliant: "سليم",
expiring: "قارب على الانتهاء",
overdue: "متأخر",
invalid: "مرفوض",
pending: "بانتظار التصديق",
missing_evidence: "مفقود",
unknown: "غير معروف",
},
bucketA11y: {
compliant_zero: "{{count}} ملتزم",
compliant_one: "{{count}} ملتزم",
compliant_two: "{{count}} ملتزم",
compliant_few: "{{count}} ملتزم",
compliant_many: "{{count}} ملتزم",
compliant_other: "{{count}} ملتزم",
expiring_zero: "{{count}} قارب على الانتهاء",
expiring_one: "{{count}} قارب على الانتهاء",
expiring_two: "{{count}} قارب على الانتهاء",
expiring_few: "{{count}} قارب على الانتهاء",
expiring_many: "{{count}} قارب على الانتهاء",
expiring_other: "{{count}} قارب على الانتهاء",
overdue_zero: "{{count}} متأخر",
overdue_one: "{{count}} متأخر",
overdue_two: "{{count}} متأخر",
overdue_few: "{{count}} متأخر",
overdue_many: "{{count}} متأخر",
overdue_other: "{{count}} متأخر",
invalid_zero: "{{count}} مرفوض",
invalid_one: "{{count}} مرفوض",
invalid_two: "{{count}} مرفوض",
invalid_few: "{{count}} مرفوض",
invalid_many: "{{count}} مرفوض",
invalid_other: "{{count}} مرفوض",
pending_zero: "{{count}} بانتظار التصديق",
pending_one: "{{count}} بانتظار التصديق",
pending_two: "{{count}} بانتظار التصديق",
pending_few: "{{count}} بانتظار التصديق",
pending_many: "{{count}} بانتظار التصديق",
pending_other: "{{count}} بانتظار التصديق",
missing_evidence: "{{count}} دليل مفقود",
unknown_zero: "{{count}} غير معروف",
unknown_one: "{{count}} غير معروف",
unknown_two: "{{count}} غير معروف",
unknown_few: "{{count}} غير معروف",
unknown_many: "{{count}} غير معروف",
unknown_other: "{{count}} غير معروف",
},
state: {
overdue: "متأخر",
overdueBy_one: "متأخر بيوم واحد",
overdueBy_other: "متأخر بـ {{count}} يوم",
expiring: "قارب على الانتهاء",
expiresToday: "ينتهي اليوم",
expiresIn_one: "ينتهي بعد يوم واحد",
expiresIn_other: "ينتهي بعد {{count}} يوم",
evidenceMissing: "الدليل مفقود",
rejected: "مرفوض",
awaitingValidation: "بانتظار التصديق",
nothingRecorded: "لم يُسجَّل شيء",
inDate: "ضمن المدة",
validFor_one: "صالح ليوم واحد",
validFor_other: "صالح لمدة {{count}} يوم",
overdueBy_zero: "متأخر منذ اليوم",
overdueBy_two: "متأخر بيومين",
overdueBy_few: "متأخر بـ {{count}} أيام",
overdueBy_many: "متأخر بـ {{count}} يومًا",
expiresIn_zero: "ينتهي اليوم",
expiresIn_two: "ينتهي بعد يومين",
expiresIn_few: "ينتهي بعد {{count}} أيام",
expiresIn_many: "ينتهي بعد {{count}} يومًا",
validFor_zero: "صالح حتى اليوم",
validFor_two: "صالح ليومين",
validFor_few: "صالح لمدة {{count}} أيام",
validFor_many: "صالح لمدة {{count}} يومًا",
},
action: {
upload_evidence: "إضافة دليل",
renew: "تجديد",
replace_rejected: "استبدال",
chase_validation: "تذكير المصدّق",
record_expiry: "إضافة تاريخ الانتهاء",
review_asset: "مراجعة الأصل",
none: "",
schedule_inspection: "تفتيش",
},
row: {
responsible: "المسؤول: {{name}}",
unassigned: "لا يوجد مُعتمِد محدد",
sourceLocalRead: "مقروء من المستند",
sourceCloudAi: "مقترح من الذكاء الاصطناعي",
sourceManual: "مُدخل يدويًا",
validatedBy: "قبِله {{name}}",
openA11y: "فتح {{label}} في {{asset}}",
},
refine: {
status: "الحالة",
site: "الموقع",
siteAny: "أي موقع",
team: "الفريق",
teamAny: "أي فريق",
assetType: "نوع الأصل",
asset: "الأصل",
requirement: "المتطلب",
due: "الاستحقاق",
dueAny: "أي وقت",
due30: "الثلاثون يومًا القادمة",
due90: "التسعون يومًا القادمة",
sortBy: "الترتيب حسب",
groupBy: "التجميع حسب",
},
sort: {
due_soonest: "الأقرب استحقاقًا",
severity: "الأكثر إلحاحًا",
asset_az: "الأصل أ-ي",
},
group: {
none: "بدون تجميع",
status: "الحالة",
asset: "الأصل",
site: "الموقع",
requirement: "المتطلب",
noSite: "بلا موقع",
noRequirement: "لم يُصرَّح بشيء",
partialCount: "{{count}}+",
},
assetDetail: {
viewRegister: "عرض الامتثال",
},
esg: {
loading: "جارٍ تحميل أرقام ESG…",
loadFailed: "تعذّر تحميل أرقام ESG.",
retry: "إعادة المحاولة",
notCoveredTitle: "ESG غير مفعّل لهذا الموقع",
notCoveredBody: "مساحة عملك تستخدم ESG في مواقع مختارة فقط. يمكن للمسؤول إضافة هذا الموقع من الخطة والفوترة.",
noMetersTitle: "لا توجد قراءات طاقة بعد",
noMetersBody: "أضف عدادًا (كهرباء أو غاز أو زيت أو حرارة أو ماء) إلى أصل وسجّل القراءات. تظهر الطاقة والكربون هنا في اليوم التالي، أو فورًا عبر تحديث.",
byFuelTitle: "الطاقة حسب المصدر (آخر 12 شهرًا)",
byMonthTitle: "الطاقة حسب الشهر",
byMonthA11y: "مخطط أعمدة للطاقة المستخدمة كل شهر خلال آخر 12 شهرًا",
unconverted: "بعض القراءات بوحدة لا يمكن تحويلها إلى كيلوواط ساعة فتم استبعادها. تحقّق من وحدة العداد.",
estimateNote: "الكربون تقدير وفق عوامل التحويل الصادرة عن الحكومة البريطانية ({{year}}). النطاق 1 هو الوقود المحروق في الموقع؛ النطاق 2 هو الكهرباء المشتراة.",
updatedAt: "حُسبت الأرقام {{when}}",
notYetComputed: "لم تُحسب بعد. اضغط تحديث.",
refresh: "تحديث",
guideMe: "أرشدني",
refreshing: "جارٍ التحديث…",
edit: "تعديل",
save: "حفظ",
cancel: "إلغاء",
remove: "إزالة",
saveFailed: "تعذّر الحفظ. تحقّق من الاتصال وحاول مجددًا.",
floorAreaTitle: "المساحة",
floorAreaLabel: "المساحة (م²)",
floorAreaHint: "تُستخدم لحساب الطاقة والكربون لكل م². أدرج المواقع الداخلية فقط إن لم تكن لها مساحة خاصة.",
floorAreaInvalid: "أدخل عدد الأمتار المربعة.",
floorAreaValue: "{{m2}} م²",
kpi: {
energy: "الطاقة",
carbon: "الكربون",
intensity: "كيلوواط ساعة لكل م²",
intensityUnit: "آخر 12 شهرًا",
needsFloorArea: "أضف المساحة",
meters: "عدادات مقروءة",
metersHint: "قُرئت خلال آخر 3 أشهر",
water: "الماء",
vsLastYear: "{{change}} مقارنة بالعام السابق",
last12m: "آخر 12 شهرًا",
scopes: "النطاق 1 {{s1}} · النطاق 2 {{s2}}",
      same: "بلا تغيير",
      lower: "↓ ‏{{pct}}٪",
      higher: "↑ ‏{{pct}}٪",
      electricity: "الكهرباء",
      electricityCarbon: "{{tonnes}} طن CO₂e، آخر 12 شهرًا",
      refrigerant: "غاز التبريد",
      refrigerantGwp: "{{refrigerant}}، معامل الاحترار {{gwp}}",
      fgasSize: "كمية الغازات المفلورة",
      fgasFormula: "{{kg}} كغ × معامل الاحترار {{gwp}}",
      fgasUnknownGwp: "معامل الاحترار غير معروف لهذا الغاز",
      leaked: "المتسرّب، آخر 12 شهرًا",
      leakedTonnes: "{{tonnes}} طن CO₂e متسرّبة",
      carbonCaption: "مقارنة بالعام الماضي، تقدير",
      vsLastYearShort: "مقارنة بالعام الماضي",
      perM2: "الطاقة لكل م²",
      perM2Caption: "آخر 12 شهرًا",
      allFuels: "كل أنواع الوقود، آخر 12 شهرًا",
},
fuel: {
electricity: "كهرباء",
gas: "غاز",
heat: "حرارة",
oil: "زيت",
water: "ماء",
},
refrigerant: {
title: "غاز التبريد (الغازات المفلورة)",
none: "لم يُسجّل غاز تبريد.",
add: "إضافة غاز تبريد",
summary_zero: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
summary_one: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
summary_two: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
summary_few: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
summary_many: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
summary_other: "{{count}} أصل يحتوي {{tonnes}} طن CO₂e من غاز التبريد؛ {{inBand}} تحتاج فحص تسرّب.",
overdue_zero: "فحوص تسرّب متأخرة: {{count}}.",
overdue_one: "فحوص تسرّب متأخرة: {{count}}.",
overdue_two: "فحوص تسرّب متأخرة: {{count}}.",
overdue_few: "فحوص تسرّب متأخرة: {{count}}.",
overdue_many: "فحوص تسرّب متأخرة: {{count}}.",
overdue_other: "فحوص تسرّب متأخرة: {{count}}.",
assetLine: "{{refrigerant}}، {{kg}} كغ ({{tonnes}} طن CO₂e)",
checkEvery: "فحص تسرّب كل {{months}} أشهر. الموعد التالي {{next}}.",
noCheckNeeded: "دون حدّ الغازات المفلورة: لا حاجة لفحص دوري.",
leakDetectionRequired: "بهذا الحجم تشترط القواعد نظامًا لكشف التسرّب.",
added12m: "أُضيف {{kg}} كغ خلال آخر 12 شهرًا",
typeLabel: "غاز التبريد",
chargeLabel: "الشحنة (كغ)",
chargeInvalid: "أدخل الشحنة بالكيلوغرام.",
leakDetection: "نظام كشف تسرّب مركّب",
hermetic: "محكم الإغلاق",
previewBand: "{{tonnes}} طن CO₂e: فحص تسرّب كل {{months}} أشهر.",
previewNone: "{{tonnes}} طن CO₂e: لا حاجة لفحص دوري.",
planNote: "نضيف فحص التسرّب إلى خطة هذا الأصل ونحافظ على الفاصل الصحيح.",
logCheck: "تسجيل فحص",
logLeak: "تسجيل تسرّب",
logTopUp: "تسجيل إعادة تعبئة",
logRecovered: "تسجيل استرداد",
kgLabel: "الكمية (كغ)",
removeTitle: "إزالة غاز التبريد؟",
removeBody: "تنتهي خطة فحص التسرّب لهذا الأصل. يبقى سجل الفحوص السابقة.",
      edit: "تعديل غاز التبريد",
      fromDetails: "الغاز من تفاصيل الأصل: {{refrigerant}}",
},
epc: {
title: "شهادات الطاقة",
none: "لم تُسجّل شهادة.",
add: "إضافة شهادة",
ratingLabel: "التصنيف",
validUntilLabel: "صالحة حتى (YYYY-MM-DD)",
validUntil: "صالحة حتى {{date}}",
dateInvalid: "أدخل التاريخ بصيغة YYYY-MM-DD.",
refLabel: "رقم الشهادة",
isLet: "المبنى مؤجَّر",
belowMinimum: "دون E: لا يجوز تأجير مبنى في إنجلترا وويلز بهذا التصنيف دون إعفاء.",
expired: "منتهية",
expiresSoon: "تنتهي خلال 6 أشهر",
documentNote: "احفظ الشهادة نفسها في المستندات كشهادة أداء الطاقة ليصلك تذكير قبل انتهائها.",
removeTitle: "إزالة هذه الشهادة؟",
      let: "مؤجَّر",
      notLet: "غير مؤجَّر",
      meetsStandard: "يستوفي الحد الأدنى للتأجير",
      open: "فتح الشهادة",
      attachFile: "إرفاق الملف",
      noFile: "لم يُرفق ملف بعد",
      addRating: "أضف التصنيف",
      keptInDocuments: "تُحفظ الشهادات مرة واحدة ضمن المستندات. التصنيف والتاريخ والتذكير تأتي من هناك.",
},
sg: {
title: "الجوانب الاجتماعية والحوكمة",
hint: "من عمليات الفحص والأعمال خلال آخر 12 شهرًا.",
compliance: "الامتثال",
risk: "متوسط المخاطر",
inspections: "عمليات الفحص",
signedOff: "{{done}} منجزة، {{signed}} معتمدة",
jobs: "الأعمال",
rework: "{{done}} منجزة، {{rework}} أُعيدت",
contractors: "المقاولون المستعان بهم",
      tile: {
        contractors: "المقاولون المستعان بهم",
        contractorsCaption: "التأمين غير مسجّل بعد",
        safety: "شهادات السلامة السارية",
        findings: "الملاحظات المعالجة في وقتها",
        signedOff: "الأعمال المخطّطة المعتمدة",
        ofCount: "{{done}} من {{total}}",
        nothingYet: "لا شيء للعدّ بعد",
      },
},
promptTitle: "ESG والاستدامة",
promptBody: "اطّلع على الطاقة والكربون وغاز التبريد وشهادات الطاقة لكل موقع وأصل، محسوبة من القراءات التي تسجّلها أصلًا. إضافة مسعّرة لكل أصل.",
promptAction: "أضفها من الخطة والفوترة",
promptAskAdmin: "اطلب من مسؤول مساحة العمل إضافتها.",
promptNotInApp: "غير متاح للشراء داخل التطبيق.",
ai: {
title: "كتابة ملخص",
hint: "ملخص قصير لهذه الأرقام مع إجراءات موصى بها. كل رقم مأخوذ مما سبق.",
reader: {
manager: "لي",
landlord: "لمالك العقار",
investor: "لمستثمر",
},
write: "كتابة ملخص",
again: "إعادة الكتابة",
writing: "جارٍ الكتابة…",
failed: "تعذّرت الكتابة. حاول مجددًا.",
noCredits: "لم يعد لدى مساحة عملك أرصدة ذكاء اصطناعي.",
plainNote: "ملخص بسيط دون استخدام أرصدة الذكاء الاصطناعي.",
actionsTitle: "الإجراءات الموصى بها",
do: {
job: "إنشاء عمل",
inspection: "فحص",
reading: "إضافة قراءة",
record: "فتح",
},
},
portfolio: {
title: "ESG للمحفظة",
hint: "كل موقع رئيسي، آخر 12 شهرًا.",
site: "الموقع",
energy: "الطاقة",
change: "التغيّر",
intensity: "ك.و.س/م²",
carbon: "الكربون",
epc: "الشهادة",
fgas: "الغازات المفلورة",
overdue: "متأخرة",
belowMinimum: "دون E",
expiring: "تنتهي قريبًا",
empty: "لا توجد مواقع بعد.",
workspaceTitle: "مساحة العمل كلها",
},
    period: "من {{from}} إلى {{to}}",
    addFloorArea: "أضف المساحة",
    addonBadge: "إضافة ESG",
    promptTitleAsset: "ESG لهذا الأصل",
    promptTitleSite: "ESG لهذا الموقع",
    promptMeters_zero: "تسجّل هنا بالفعل {{count}} عدّادات ({{kinds}}). مع إضافة ESG تتحوّل قراءاتها فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptMeters_one: "تسجّل هنا بالفعل {{count}} عدّاد ({{kinds}}). مع إضافة ESG تتحوّل قراءاته فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptMeters_two: "تسجّل هنا بالفعل {{count}} عدّادات ({{kinds}}). مع إضافة ESG تتحوّل قراءاتها فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptMeters_few: "تسجّل هنا بالفعل {{count}} عدّادات ({{kinds}}). مع إضافة ESG تتحوّل قراءاتها فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptMeters_many: "تسجّل هنا بالفعل {{count}} عدّادات ({{kinds}}). مع إضافة ESG تتحوّل قراءاتها فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptMeters_other: "تسجّل هنا بالفعل {{count}} عدّادات ({{kinds}}). مع إضافة ESG تتحوّل قراءاتها فورًا إلى أرقام الطاقة والكربون والمقارنة السنوية.",
    promptNothingHidden: "لا شيء مما تسجّله يُخفى أو يضيع: تبقى العدّادات والقراءات والمستندات كما هي.",
    header: {
      floorArea: "المساحة {{value}} م²",
      rating: "تصنيف {{scheme}} {{rating}}",
    },
    csv: {
      defaultName: "بيانات ESG",
    },
    actions: {
      exportCsv: "تصدير ESG بصيغة CSV",
      share: "مشاركة تقرير ESG",
      openAsset360: "فتح الأصل 360",
      openSite360: "فتح الموقع 360",
    },
    chart: {
      electricityTitle: "الكهرباء حسب الشهر",
      energyTitle: "الطاقة حسب الشهر",
      subElectricity_zero: "ميغاواط ساعة، من {{count}} عدّادات",
      subElectricity_one: "ميغاواط ساعة، من {{count}} عدّاد",
      subElectricity_two: "ميغاواط ساعة، من {{count}} عدّادات",
      subElectricity_few: "ميغاواط ساعة، من {{count}} عدّادات",
      subElectricity_many: "ميغاواط ساعة، من {{count}} عدّادات",
      subElectricity_other: "ميغاواط ساعة، من {{count}} عدّادات",
      subEnergy_zero: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّادات",
      subEnergy_one: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّاد",
      subEnergy_two: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّادات",
      subEnergy_few: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّادات",
      subEnergy_many: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّادات",
      subEnergy_other: "ميغاواط ساعة، كل أنواع الوقود، من {{count}} عدّادات",
      a11y: "{{title}}: عمود لكل شهر من آخر 12 شهرًا وخط متقطّع للشهر نفسه في العام الماضي",
      valueWithLastYear: "{{month}}: {{value}} ميغاواط ساعة (العام الماضي {{last}} ميغاواط ساعة)",
      value: "{{month}}: {{value}} ميغاواط ساعة",
      tapHint: "اضغط على عمود لترى قيمته.",
      thisYear: "هذا العام",
      lastYear: "العام الماضي",
      metersReporting: "{{reporting}} من {{total}} عدّادات تُرسل قراءات (خلال آخر 3 أشهر)",
    },
    carbon: {
      title: "من أين يأتي الكربون",
      sub: "آخر 12 شهرًا، تقدير بمعاملات {{year}}",
      scope: "النطاق {{n}}",
      refrigerantLeak: "تسرّب غاز التبريد، {{name}}",
      none: "لم يُحسب أي كربون بعد. أضف قراءات العدّادات أو سجّل إعادة تعبئة غاز التبريد.",
      fuelsTitle: "الطاقة حسب نوع الوقود",
    },
    fgas: {
      titleWithEpc: "الغازات المفلورة وشهادات الطاقة",
      none: "لا يوجد غاز تبريد مسجّل في هذا الموقع.",
      row: "{{name}}: {{refrigerant}}، {{kg}} كغ ({{tonnes}} طن CO₂e)",
      overdue: "فحص التسرّب متأخر",
      due: "فحص التسرّب مستحق في {{date}}",
      noCheck: "لا يلزم فحص تسرّب",
      openJobFor: "فتح مهمة {{name}}",
      bookFor: "حجز فحص تسرّب لـ {{name}}",
      jobTitle: "فحص تسرّب الغازات المفلورة: {{name}}",
      jobDescription: "فحص تسرّب نظام {{refrigerant}} ({{kg}} كغ، {{tonnes}} طن CO₂e) بواسطة فني معتمد. سجّل النتيجة وأي غاز تبريد مُضاف.",
    },
    leak: {
      title: "فحوص التسرّب",
      sub: "عدد مرات فحص التسرّب التي تطلبها قواعد الغازات المفلورة، حسب الكمية بالطن CO₂e.",
      every: "كل {{months}} أشهر",
      noneNeeded: "غير مطلوب",
      band: {
        none: "أقل من 5 طن",
        "5-50": "من 5 إلى 50 طن",
        "50-500": "من 50 إلى 500 طن",
        "500+": "500 طن فأكثر",
      },
      lastCheck: "آخر فحص {{date}}: {{result}}",
      resultLeak: "وُجد تسرّب",
      resultPassed: "ناجح",
      noCheckYet: "لم يُسجّل أي فحص تسرّب بعد.",
      overdue: "متأخر منذ {{date}}",
      nextDue: "الفحص التالي في {{date}}",
      openJob: "فتح المهمة",
      logTitle: "سجل التسرّب",
      logEmpty: "لم يُسجّل شيء بعد.",
      event: {
        leak_check: "فحص تسرّب",
        leak_found: "وُجد تسرّب",
        top_up: "إعادة تعبئة {{kg}} كغ",
        recovered: "استرداد {{kg}} كغ",
      },
      showFewer: "عرض أقل",
      seeAll: "عرض الكل ({{total}})",
      callout: "كل إعادة تعبئة تُحسب تسرّبًا: الكغ × معامل الاحترار تُضاف إلى كربون النطاق 1.",
    },
    units: {
      mwh: "{{value}} ميغاواط ساعة",
      kwh: "{{value}} كيلوواط ساعة",
      kg: "{{value}} كغ",
      t: "{{value}} طن",
      mwhAxis: "ميغاواط ساعة",
    },
},
};
